import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  role: null, // Role enum value
  stage: null, // Stage enum value
  registrationStatus: null, // Registration status enum value
  stages: [],
  characters: [], // רשימת הדמויות מה-API
  isSchoolRegistered: null,
  achievements: {
    stars: 0, // כוכבים
    challenges: 0, // שלבים שהושלמו
    characterRank: null, // דמות הדרגה
    myScoreboardData: {
      myClassPlace: 8,
      mySchoolPlace: 1,
      participant: 54,
      mySchoolType: "stateReligious",
    },
    counter: {
      students: 0,
      schools: 0,
    },
  },
  schoolClasses: [],
  schoolAchievements: {
    totalStars: 0,
    participatingStudentsCount: 0,
  },
  activeContests: [],
  currentContestId: null,
  contentInfoJson: null,
  moveUserToFinalPage: true,
  finalStatus: {
    isSchoolInFinal: true,
    isTeamMember: true,
    isSchoolRegisteredForFinal: true,
    finalRank: 0,
  },
  finalData: {
    minutesUntilFinal: 0,
    isFinalOpen: true,
    isFinalEnd: true,
    finalDate: "2026-02-26T11:33:31.290Z",
    isFinalPageAvailable: true,
    isFinalTrainingTeams: true,
    finalRegistrationEnd: true,
    regulationUrl: "string",
    registrationLink: "string"
  },
  finalIsAloud: {
    isTeamMember: true,
    minutesUntilFinal: 0,
    isFinalOpen: true,
    isFinalEnd: true
  },
  isLoading: false,
  initContestData: false,
  error: null,
  timerReached10Minutes: false, // מתעדכן כשנשארו 10 דקות או פחות לטיימר הגמר
};

const contestSlice = createSlice({
  name: 'contest',
  initialState,
  reducers: {
    setContestState: (state, action) => {
      const newState = {
        ...state,
        ...action.payload,
      };
      return newState;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setStages: (state, action) => {
      state.stages = action.payload;
    },
    setCharacters: (state, action) => {
      state.characters = action.payload;
    },
    setInitContestData: (state, action) => {
      state.initContestData = action.payload;
    },
    setActiveContests: (state, action) => {
      state.activeContests = action.payload;
    },
    setContentInfoJson: (state, action) => {
      state.contentInfoJson = action.payload;
    },
    setCurrentContestId: (state, action) => {
      state.currentContestId = action.payload;
    },
    setTimerReached219Minutes: (state, action) => {
      state.timerReached219Minutes = action.payload;
    },
    setFinalStatus: (state, action) => {
        state.finalStatus = { ...state.finalStatus, ...action.payload.finalStatus };
        state.finalData = { ...state.finalData, ...action.payload.finalData };
    },
    setMoveUserToFinalPage: (state, action) => {
      state.moveUserToFinalPage = action.payload;
    }
  },
});

export const contestActions = contestSlice.actions;
export const { setContestState, setStages, setCharacters, setFinalStatus } = contestSlice.actions;
export default contestSlice;
